import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'src/app/_metronic/shared/shared.module';

import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/_metronic/shared/components/toast/toast.service';

@Component({
  selector: 'app-forgot-password-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, SharedModule],
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.scss']
})
export class ForgotPasswordFormComponent implements OnInit {
  @Output() backClick = new EventEmitter<void>();
  @Output() submitSuccess = new EventEmitter<string>();

  forgotPasswordForm!: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private authService: AuthService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  getErrorMessage(): string {
    const field = this.forgotPasswordForm.get('email');
    if (field?.hasError('required')) {
      return this.translate.instant('LOGIN.VALIDATION.EMAIL_REQUIRED');
    }
    if (field?.hasError('email')) {
      return this.translate.instant('LOGIN.VALIDATION.EMAIL_INVALID');
    }
    return '';
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const email = this.forgotPasswordForm.value.email;

    this.authService.requestForgotPassword(email).subscribe({
        next: (res) => {
            this.isLoading = false;
            this.submitSuccess.emit(email);
            this.cdr.detectChanges();
        },
        error: (err) => {
            this.isLoading = false;
            console.error('Forgot Password Error:', err); // Log for debugging
            const errorMsg = err?.error?.message || 'Failed to request password reset';
            this.toastService.error(errorMsg);
            this.cdr.detectChanges();
        }
    });
  }

  onBackClick(): void {
    this.backClick.emit();
  }
}
